// extracted by mini-css-extract-plugin
export default {"lastUpdatedLabel":"LastUpdatedLabel_lastUpdatedLabel__9unzD","lastUpdatedText":"LastUpdatedLabel_lastUpdatedText__p6HGm"};